import { api } from "./client";
import type { BackCheckinRequest, BackCheckinResponse, BackHistoryResponse } from "@/types";

export async function submitBackCheckin(
  payload: BackCheckinRequest,
): Promise<BackCheckinResponse> {
  const { data } = await api.post<BackCheckinResponse>("/back/checkin", payload);
  return data;
}

export async function getBackHistory(days = 30): Promise<BackHistoryResponse> {
  const { data } = await api.get<BackHistoryResponse>(`/back/history?days=${days}`);
  return data;
}
